import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'
import './index.scss'

import favIcon57x57 from '../images/icons/apple-touch-icon-57x57.png';
import favIcon60x60 from '../images/icons/apple-touch-icon-60x60.png';
import favIcon72x72 from '../images/icons/apple-touch-icon-72x72.png';
import favIcon76x76 from '../images/icons/apple-touch-icon-76x76.png';
import favIcon114x114 from '../images/icons/apple-touch-icon-114x114.png';
import favIcon120x120 from '../images/icons/apple-touch-icon-120x120.png';
import favIcon144x144 from '../images/icons/apple-touch-icon-144x144.png';
import favIcon152x152 from '../images/icons/apple-touch-icon-152x152.png';
import favIcon180x180 from '../images/icons/apple-touch-icon-180x180.png';
import favIcon32x32 from '../images/icons/favicon-32x32.png';
import favIcon192x192 from '../images/icons/android-chrome-192x192.png';
import favIcon96x96 from '../images/icons/favicon-96x96.png';
import favIcon16x16 from '../images/icons/favicon-16x16.png';
import favIcon from '../images/icons/favicon.ico';


const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Official HBO Shop UK"
      meta={[
        { name: 'description', content: 'HBO has decided to cease operation of the HBO UK, FR, DE, & EU Shops. We are no longer offering merchandise for sale through these portals. Below, you can find out about other HBO products and how to stay connected to your favorite HBO shows.' },
      ]}
    >
      <link rel="apple-touch-icon" sizes="57x57" href={favIcon57x57} />
    	<link rel="apple-touch-icon" sizes="60x60" href={favIcon60x60} />
    	<link rel="apple-touch-icon" sizes="72x72" href={favIcon72x72} />
    	<link rel="apple-touch-icon" sizes="76x76" href={favIcon76x76} />
    	<link rel="apple-touch-icon" sizes="114x114" href={favIcon114x114} />
    	<link rel="apple-touch-icon" sizes="120x120" href={favIcon120x120} />
    	<link rel="apple-touch-icon" sizes="144x144" href={favIcon144x144} />
    	<link rel="apple-touch-icon" sizes="152x152" href={favIcon152x152} />
    	<link rel="apple-touch-icon" sizes="180x180" href={favIcon180x180} />
    	<link rel="icon" type="image/png" href={favIcon32x32} sizes="32x32" />
    	<link rel="icon" type="image/png" href={favIcon192x192} sizes="192x192" />
    	<link rel="icon" type="image/png" href={favIcon96x96} sizes="96x96" />
    	<link rel="icon" type="image/png" href={favIcon16x16} sizes="16x16" />
    	<link rel="shortcut icon" href={favIcon} />
    </Helmet>
    <Header />
    <div className="page">
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper


// WEBPACK FOOTER //
// ./src/layouts/index.js